// Razorpay Checkout helper. Uses the script loaded in public/index.html.
export function openRazorpayCheckout({ orderId, amount, currency = "INR", keyId, name = "Rate-ED", description, prefill = {}, onSuccess, onDismiss }) {
  if (typeof window === "undefined" || !window.Razorpay) {
    throw new Error("Razorpay SDK not loaded");
  }
  const rzp = new window.Razorpay({
    key: keyId,
    amount,
    currency,
    name,
    description,
    order_id: orderId,
    prefill,
    theme: { color: "#13A699" },
    handler: (response) => {
      onSuccess && onSuccess(response);
    },
    modal: {
      ondismiss: () => onDismiss && onDismiss(),
    },
  });
  rzp.open();
}
